import { EquipmentHandler } from './equipmentHandler';
import { PipelineHandler } from './pipelineHandler';
import { StructuralHandler } from './structuralHandler';
import { AnnotationHandler } from './annotationHandler';
import { InspectionHandler } from './inspectionHandler';
import { ScaffoldHandler } from './scaffoldHandler';
import { AnomaliesHandler } from './anomaliesHandler';
import { AvaInspectHandler } from './avaInspectHandler';

/**
 * Factory for creating and managing tag handlers
 */
export const tagHandlers = {
    /**
     * Create all tag handlers
     * @param {Object} extension - The parent extension
     * @returns {Object} Handler manager
     */
    createHandlers(extension) {
        const handlers = {
            'equipment': new EquipmentHandler(extension),
            'equipment_2d': new EquipmentHandler(extension),
            'auto_equipment': new EquipmentHandler(extension),
            'pipeline': new PipelineHandler(extension),
            'manual_pipelines': new PipelineHandler(extension),
            'structural': new StructuralHandler(extension),
            'manual_structural': new StructuralHandler(extension),
            'annotation': new AnnotationHandler(extension),
            'inspection': new InspectionHandler(extension),
            'amisTag': new InspectionHandler(extension),
            'severity': new InspectionHandler(extension),
            'scaffold': new ScaffoldHandler(extension),
            'permit': new ScaffoldHandler(extension),
            'container': new ScaffoldHandler(extension),
            'anomaly': new AnomaliesHandler(extension),
            'ava-inspect': new AvaInspectHandler(extension)
        };

        return {
            /**
             * Get handler for specific tag type
             * @param {string} type - Tag type
             * @returns {Object|null} Handler for the tag type
             */
            getHandler(type) {
                return handlers[type] || null;
            },
            clearClusterTextMeshes() {
                Object.values(handlers).forEach(handler => handler.clearClusterTextMeshes());
            },
            /**
             * Drop every handler's cached 2D projection. The cache only rebuilds when the
             * tag count changes, so a same-count position change must clear it explicitly.
             */
            resetClusterCaches() {
                Object.values(handlers).forEach(handler => handler.resetClusterCache());
            }
        };
    },
};
